/**
 * Состояние screen lock вне React (для api-client).
 * unlock token хранится только в памяти процесса.
 */

let unlockTokenMemory: string | null = null;
let locked = false;

export const screenLockGate = {
  get isLocked() {
    return locked;
  },
  setLocked(v: boolean) {
    locked = v;
  },
  getUnlockToken() {
    return unlockTokenMemory;
  },
  setUnlockToken(token: string | null) {
    unlockTokenMemory = token;
  },
};
